import React, { Component } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import moment from "moment";

const options = [
  { value: "1", label: "English" },
  { value: "2", label: "Hindi" },
  { value: "3", label: "Tamil" },
  { value: "4", label: "Telugu" },
  { value: "5", label: "Malayalam" },
  { value: "6", label: "Urdu" },
  { value: "7", label: "Assamese" },
  { value: "8", label: "Bengali" },
  { value: "9", label: "Gujarati" },
  { value: "10", label: "Kannada" },
  { value: "11", label: "Kashmiri" },
  { value: "12", label: "Konkani" },
  { value: "13", label: "Manipuri" },
  { value: "14", label: "Marathi" },
  { value: "15", label: "Nepali" },
  { value: "16", label: "Oriya" },
  { value: "17", label: "Punjabi" },
  { value: "18", label: "Sanskrit" },
  { value: "19", label: "Sindhi" },
  { value: "20", label: "Bodo" },
  { value: "21", label: "Santhali" },
  { value: "22", label: "Maithili" },
  { value: "23", label: "Dogri" },
];

class PersonalInformation extends Component {
  filterselectdservices = (selectedServices) => {
    if (selectedServices.length > 0) {
      let newSelectedServices = [];
      selectedServices.map((service) => {
        let selectedService = options.find((option) => option.value == service);
        newSelectedServices.push(selectedService);
      });
      return newSelectedServices;
    }
  };
  render() {
    const {
      firstName,
      lastName,
      dateOfBirth,
      contact,
      emailId,
      gender,
      permanentAddress,
      pincode,
      panNumber,
      adharNumber,
      profilePicReview,
      addPhotoText,
      isServiceLoading,
      isPanAvailable,
      aadharDocs,
      isAadharAvailable,
      formatDate,
      selectedOption,
      experience,
      logoutHandler,
    } = this.props;
    return (
      <form
        className="mainPersonalDiv"
        onSubmit={(e)=>this.props.personalInformationSubmitHandler(e)}
      >
        <Row>
          <Col className="imageUpload mt-4 d-flex justify-content-center ml-4">
          <label htmlFor="file-input">
            <img
              src={profilePicReview}
              alt=""
              className="img-fluid img-circle"
              style={{ cursor: "pointer" , maxWidth:"80%" }}
            />
          </label>
          <div className="file-input-wrapper">
            <div className="btn-file-input">
              <input
                id="file-input"
                type="file"
                name="profilePic"
                placeholder="photos"
                onChange={this.props.profilePicChangeHandler}
                required={profilePicReview ? false : true}
              />
            </div>
          </div>
          </Col>
        </Row>
        <div className="personalDiv mb-2">
          <Input
            className="inpPer"
            type="text"
            id="firstname"
            name="firstName"
            placeholder="Name"
            pattern="^[a-zA-Z][a-zA-Z\\s]+$"
            value={firstName}
            onChange={(e)=>this.props.onChangeHandler(e)}
            required={firstName ? false : true}
          />
        </div>
        <div className="personalDiv mb-2">
          <Input
            className="inpPer"
            type="text"
            id="lastName"
            name="lastName"
            placeholder="Last Name"
            pattern="^[a-zA-Z][a-zA-Z\\s]+$"
            value={lastName}
            onChange={(e)=>this.props.onChangeHandler(e)}
            required={lastName ? false : true}
          />
        </div>
        <div className="personalDiv mb-2">
          <Input
            className="inpPer"
            type="tel"
            id="phonenumber"
            name="contact"
            placeholder="Phone Number"
            pattern="[6-9]{1}[0-9]{9}"
            value={contact}
            onChange={(e)=>this.props.onChangeHandler(e)}
            disabled
          />
        </div>
        <div className="personalDiv mb-2">
          <Input
            className="inpPer"
            type="email"
            id="email"
            name="emailId"
            placeholder="Last Name"
            pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
            value={emailId}
            onChange={(e)=>this.props.onChangeHandler(e)}
            disabled
          />
        </div>
        <div className="personalDiv mb-2">
          {/* <Input
            className="inpPer"
            type="text"
            placeholder="DOB"
            value={dateOfBirth}
            onChange={(e)=>this.props.handleDayChange(e)}
            onFocus={(e) => (e.target.type = "date")}
            onBlur={(e) => (e.target.type = "text")}
            max={moment().format("DD-MM-YYYY")}
            required={dateOfBirth ? false : true}
          /> */}
          <DatePicker
            className="inpPer"
            placeholderText={!dateOfBirth && "DOB"}
            selected={dateOfBirth}
            onChange={(e)=>this.props.handleDayChangePer(e)}
            maxDate={new Date()}
            showYearDropdown
            dropdownMode="select"
          />
        </div>
        <div className="personalDiv">
          {/* <div className="col"> */}
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="gender"
              id="male"
              value="1"
              checked={gender === "1" || gender === 1}
              onChange={(e)=>this.props.onChangeHandler(e)}
              required={gender ? false : true}
            />
            <label className="form-check-label gen" htmlFor="male">
              Male
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              className="form-check-input ml-2"
              type="radio"
              name="gender"
              id="female"
              value="2"
              checked={gender === "2" || gender === 2}
              onChange={(e)=>this.props.onChangeHandler(e)}
              required={gender ? false : true}
            />
            <label className="form-check-label gen" htmlFor="female">
              Female
            </label>
          </div>
          {/* </div> */}
        </div>

        {/* Contact */}
        <div
          className="mt-3"
          style={{
            background: "#F5F5F5",
            margin: "2%",
            padding: "6%",
            borderRadius: "10px",
            fontSize: "12px",
          }}
        >
          <div className="con-Id mb-3">
            <span>Contact & ID proof Details</span>
          </div>
          <div className="selectOptions">
            <FormGroup>
              <Input
                name="permanentAddress"
                value={permanentAddress}
                onChange={(e)=>this.props.onChangeHandler(e)}
                rows="3"
                type="textarea"
                placeholder="Write Your Complete Address"
                required={permanentAddress ? false : true}
                minLength="10"
                maxLength="110"
                id="permanentAddress"
                className="txtBox"
                style={{ fontSize: "12px" }}
              />
            </FormGroup>
          </div>
          <Row>
            <Col xs="6">
              <FormGroup>
                <input
                  type="text"
                  className="form-control"
                  id="pincode"
                  name="pincode"
                  pattern="[1-9]{1}[0-9]{5}"
                  minLength={6}
                  maxLength={6}
                  value={pincode}
                  onChange={(e)=>this.props.onChangeHandler(e)}
                  placeholder="pincode"
                  required={pincode ? false : true}
                  style={{
                    background: "white",
                    borderColor: "white",
                    fontSize: "12px",
                  }}
                />
              </FormGroup>
            </Col>
            <Col xs="6">
              <input
                className="form-control"
                type="number"
                name="experience"
                value={experience}
                onChange={(e)=>this.props.onChangeHandler(e)}
                placeholder="Experience"
                min="1"
                max="60"
                required={experience ? false : true} 
                style={{
                  background: "white",
                  borderColor: "white",
                  fontSize: "12px",
                }}
              ></input>
            </Col>
            <Col xs="12">
              <div className="form-group">
                <Select
                  className="formControl border-0"
                  name="language"
                  isMulti="true"
                  value={this.filterselectdservices(this.props.selectedOption)}
                  onChange={(e)=>this.props.handleChange(e)}
                  options={options}
                  required={selectedOption.length>0 ? false : true} 
                  placeholder='select languages'
                />
              </div>
            </Col>

            <Col md="12">
              <div className="form-group">
                <input
                  className="form-control"
                  type="text"
                  id="pannumber"
                  placeholder="Pan Number*"
                  pattern="[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"
                  style={{
                    fontSize: "12px",
                    border: "none",
                  }}
                  minLength={10}
                  maxLength={10}
                  name="panNumber"
                  value={panNumber}
                  onChange={(e)=>this.props.onChangeHandler(e)}
                  required={panNumber ? false : true} 
                />
              </div>
            </Col>
            <Col md="12">
              <label class="label">
                <input
                  type="file"
                  id="panattachment"
                  placeholder="KH-146, Gali No-27"
                  name="panattachment"
                  onChange={(e)=>this.props.panFileChangeHandler(e)}
                  required={isPanAvailable.length>0 ? false : true}
                />
                <span class="name1">
                  <i className="bi bi-download downloadIcon"></i>Choose file
                </span>
              </label>
              {isPanAvailable.length > 0 ? (
                <span className="file_message">
                  {
                    isPanAvailable.split("/")[
                      isPanAvailable.split("/").length - 1
                    ]
                  }
                </span>
              ) : (
                <span className="file_message">Choose PAN file</span>
              )}
            </Col>
            <Col md="12">
              <FormGroup>
                <Input
                  type="text"
                  className="form-control"
                  id="adharnumber"
                  placeholder="Aadhar Number*"
                  minLength={12}
                  maxLength={12}
                  name="adharNumber"
                  pattern="[0-9]{4}[0-9]{4}[0-9]{4}"
                  value={adharNumber}
                  onChange={(e)=>this.props.onChangeHandler(e)}
                  required={adharNumber ? false : true} 
                  style={{ fontSize: "12px", border: "none" }}
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <label class="label">
                <input
                  type="file"
                  id="adharattachment"
                  multiple
                  name="adharattachment"
                  onChange={(e)=>this.props.adharFileChangeHandler(e)}
                  required={isAadharAvailable.length>0 ? false : true}
                />
                <span class="name1">
                  <i className="bi bi-download downloadIcon"></i>Choose file
                </span>
              </label>
              {isAadharAvailable.length > 0 ? (
                isAadharAvailable.map((data) => (
                  <span className="file_message">
                    {" "}
                    {data.split("/")[data.split("/").length - 1]}
                  </span>
                ))
              ) : (
                <span className="file_message">Choose Aadhar file</span>
              )}
            </Col>
          </Row>
        </div>

        {isServiceLoading === true ? (
          <Row>
            <Col className="d-flex justify-content-center p-2 my-3">
              <Button
                type="submit"
                color="warning"
                style={{ color: "#fff" }}
                className="px-5"
              >
                <span class="spinner-border spinner-border-sm" />
                Save & Next
              </Button>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col className="d-flex justify-content-center p-2 my-3">
              <Button
                type="submit"
                color="warning"
                style={{ color: "#fff" }}
                className="px-5"
              >
                Save & Next
              </Button>
            </Col>
          </Row>
        )}
      </form>
    );
  }
}

export default PersonalInformation;
